export default "__VITE_ASSET__J3IQpV9I__"